import { faCaretDown, faCheck, faColumns, faCompress, faCopy, faExpand } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Button, DropdownItem, DropdownMenu, DropdownToggle, InputGroup, Toast, ToastBody, UncontrolledDropdown } from 'reactstrap';
import { AppName } from '../Admin/Admin';
import { InquiryForm } from './InquiryForm';
import { SearchBar, PageTitle } from '@galop/component-library';
import { makeCall } from '../../auth-utils';
import { api, globalErrorHandler } from '../../api/create-api';
import { useBSToasts } from '../Shared/BSToasts';

export const Embed = (props) => {
    const ls = require('local-storage');
    const { CurrentUser } = props;
    const moduleName = "Embedded Form";
    const [selectedProperty, setSelectedProperty] = useState(ls('selected-property'));
    const [properties, setProperties] = useState([]);
    const [filteredProperty, setFilteredProperty] = useState('');
    const [filteredProperties, setFilteredProperties] = useState(null);
    const [editing, setEditing] = useState(false);
    const [errors, addError, removeError] = useBSToasts([]);
    const [srcUrl, setSRCUrl] = useState(null);
    const [urlCopied, setURLCopied] = useState(false);
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        getProperties();
    }, [CurrentUser]);

    useEffect(() => {
        if (selectedProperty) {
            ls('selected-property', selectedProperty);
            setSRCUrl(`${window.location.origin}?propertyIdentifier=${selectedProperty.propertyIdentifier}`);
        }
    }, [selectedProperty]);

    useEffect(() => {
        FilterProperties(properties);
    }, [filteredProperty]);

    const getProperties = (callback) => {
        makeCall(async (authHeader) => {
            const result = await api(`api/properties?loadFullObject=true`, { headers: authHeader })
                .catch(error => globalErrorHandler(error, addError));

            if (result && result.data) {
                setProperties(result.data);
                FilterProperties(result.data);

                if (typeof callback === 'function') {
                    callback(result.data);
                }
            }
        });
    };

    const FilterProperties = (unfiltered) => {
        let filteredList = [];

        if (filteredProperty !== "") {
            filteredList = unfiltered.filter(resource => {
                const lcFilter = filteredProperty.toLowerCase();

                // Search by table columns
                const name = (resource.name || '').toLowerCase(); // Name
                const propertyName = (resource.propertyName || '').toLowerCase(); // Name


                return name.includes(lcFilter)
                    || propertyName.includes(lcFilter);
            });
        }
        else {
            filteredList = unfiltered;
        }

        setFilteredProperties(filteredList);
    };

    const ChangeProperty = (value) => {
        if (properties && properties.length > 0) {
            const selected = properties.filter(property => property.id === value)[0];
            if (selected) {
                setFilteredProperty('');
                setSelectedProperty(selected);
            }
        }
    };

    return (
        <div className="h-100 d-flex flex-column">
            <PageTitle moduleName={moduleName} flexBehavior="flex-wrap" AppName={AppName} titleChild={
                <div className="text-dark flex-fill ms-1">
                    {(selectedProperty || {}).name || 'Select Property'}
                    {properties && properties.length > 0 && (<UncontrolledDropdown className="d-inline-block">
                        <DropdownToggle size="sm" color="light" disabled={editing} className="border ms-1"><FontAwesomeIcon icon={faCaretDown} /></DropdownToggle>
                        <DropdownMenu end className="shadow">
                            {properties && properties.length > 12 &&
                                <div className="px-2">
                                    <SearchBar value={filteredProperty} onChange={(value) => setFilteredProperty(value)} placeHolder="Search Properties" Reset={() => setFilteredProperty('')} />
                                </div>
                            }
                            <div style={properties && properties.length > 12 ? { maxHeight: 280, overflow: 'scroll' } : null}>
                                {filteredProperty && filteredProperties.length > 0 && <DropdownItem divider />}
                                {filteredProperty && filteredProperties.length > 0 && <DropdownItem header>Search Results</DropdownItem>}
                                {filteredProperty && filteredProperties.slice(0, 5).map(property => <DropdownItem key={property.id} active={property.id === (selectedProperty || {}).id} onClick={() => ChangeProperty(property.id)}>{property.name}</DropdownItem>)}
                                {properties && properties.length > 12 && <DropdownItem divider />}
                                {properties.map(property => <DropdownItem key={property.id} active={property.id === (selectedProperty || {}).id} onClick={() => ChangeProperty(property.id)}>{property.name}</DropdownItem>)}
                            </div>
                        </DropdownMenu>
                    </UncontrolledDropdown>)}
                </div>
            }>
            </PageTitle>
            {selectedProperty ?
                <div className="flex-fill d-flex flex-column align-items-start">
                    <div>
                        <InputGroup className="mb-0">
                            <div className="form-control bg-white">
                                {srcUrl}
                            </div>
                            <Button color="secondary" onClick={() => copyURL({
                                srcUrl,
                                active: () => {
                                    setURLCopied(true);
                                    addError('Web Form URL copied!', { appearance: 'info', id: 'copied' });
                                },
                                inactive: () => {
                                    setURLCopied(false);
                                    removeError('copied');
                                }
                            })}><FontAwesomeIcon icon={urlCopied ? faCheck : faCopy} /></Button>
                        </InputGroup>
                    </div>
                    <div className="text-dark mb-2"><small>Copy the URL to embed in your website.</small></div>
                    <span className="h3">Preview</span>
                    <div style={expanded ? { width: 1200, height: 505 } : { width: 375, height: 505 }}>
                        <iframe className="shadow-lg p-1 border" src={srcUrl} width="100%" height="100%" />
                    </div>
                    <div style={expanded ? { width: 1225 } : { width: 400 }} className="flex-fill text-end cursor-pointer"><FontAwesomeIcon icon={expanded ? faCompress : faExpand} onClick={() => setExpanded(!expanded)} /></div>
                </div>
                :
                <div className="text-dark">Select a property to preview the embedded form.</div>
            }
            {errors}
        </div>
    );
};

export const copyURL = async (args) => {
    if (args) {
        const { active, srcUrl, inactive } = args || {};
        await navigator.clipboard.writeText(srcUrl);
        if (active && typeof active === 'function') {
            active();
            setTimeout(() => {
                if (inactive && typeof inactive === 'function') {
                    inactive();
                }
            }, 3000);
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/Inquiries/Embed.js